(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* global module:false */
"use strict";

var $ = window.$;

var TPBS_AdvSearch = (function(){

  function clearNewsCriteria()
  {
    $('#search-news-type').val('');
    $('#search-news-category').val('');
    $('#search-news-time').val('');
    $('#search-news-min').val('');
    $('#search-news-max').val('');

    $('#news-type-selector .text').html('ทุกประเภท');
    $('#news-category-selector .text').html('ทุกหมวดหมู่');
    $('#news-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearProgramCriteria()
  {
    $('#search-program-type').val('');
    $('#search-program-category').val('');
    $('#search-program-time').val('');
    $('#search-program-min').val('');
    $('#search-program-max').val('');

    $('#program-type-selector .text').html('ทุกประเภท');
    $('#program-category-selector .text').html('ทุกหมวดหมู่');
    $('#program-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearOrgCriteria()
  {
    $('#search-org-type').val('');
    $('#search-org-time').val('');
    $('#search-org-min').val('');
    $('#search-org-max').val('');

    $('#org-type-selector .text').html('ทุกประเภท');
    $('#org-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearSearchCriteria(target)
  {
    if(target == 'program'){
      clearNewsCriteria();
      clearOrgCriteria();
    }else if(target == 'org'){
      clearNewsCriteria();
      clearProgramCriteria();
    }else{
      clearOrgCriteria();
      clearProgramCriteria();
    }
  }
  
  function init(){
    if($('.advance-search-block').size() > 0){
      var momentNow = moment();

      // --- NEWS
      // init inline calendar
      $('#date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#custom-range-modal', function(e){
        console.log('modal shown');
        $('#date-range-start').focus();
      }).on('hidden.bs.modal', '#custom-range-modal', function(e){
        // clear value
        $('#date-range-start').val();
        $('#date-range-end').val();
        //$('#date-range-start-cal').data("DateTimePicker").maxDate(false);
        //$('#date-range-end-cal').data("DateTimePicker").minDate(false);
      });

      // focus to show cal
      $(document).on('focus', '#date-range-start, #date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#news-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#custom-range-modal').modal('hide');
      });
      // -- end NEWS

      // --- PROGRAM
      // init inline calendar
      $('#program-date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#program-date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#program-date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#program-date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#program-date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#program-date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#program-date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#program-date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#program-custom-range-modal', function(e){
        console.log('modal shown');
        $('#program-date-range-start').focus();
      }).on('hidden.bs.modal', '#program-custom-range-modal', function(e){
        // clear value
        $('#program-date-range-start').val();
        $('#program-date-range-end').val();
      });

      // focus to show cal
      $(document).on('focus', '#program-date-range-start, #program-date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#program-date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#program-date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#program-date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#program-date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#program-date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#program-date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#program-date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#program-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#program-custom-range-modal').modal('hide');
      });
      // -- end PROGRAM

            // --- ORG
      // init inline calendar
      $('#org-date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#org-date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#org-date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#org-date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#org-date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#org-date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#org-date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#org-date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#org-custom-range-modal', function(e){
        console.log('modal shown');
        $('#org-date-range-start').focus();
      }).on('hidden.bs.modal', '#org-custom-range-modal', function(e){
        // clear value
        $('#org-date-range-start').val();
        $('#org-date-range-end').val();
      });

      // focus to show cal
      $(document).on('focus', '#org-date-range-start, #org-date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#org-date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#org-date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#org-date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#org-date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#org-date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#org-date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#org-date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#org-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#org-custom-range-modal').modal('hide');
      });
      // -- end ORG

      $(document).on('click', '.advance-search-block .dropdown-menu a', function(e){
        e.preventDefault();
        // get text
        var _self = $(this);
        var txt = _self.text();
        var val = _self.data('value');
        var btnName = _self.closest('.dropdown-menu').attr('aria-labelledby');
        var $btn = $('#' + btnName);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);

        // get root
        var root_id = _self.closest('.tab-pane').attr('id');

        /*if(root_id == 'search-news-program'){
          clearSearchCriteria('program');
        }else if(root_id == 'search-news-org'){
          clearSearchCriteria('org');
        }else if(root_id == 'search-news-tag'){
          clearSearchCriteria('news');
        }*/

        // check if this is custom date
        if(val == 'custom'){
          // show modal
          if(root_id == 'search-news-program'){
            $('#program-custom-range-modal').modal();
          }else if(root_id == 'search-news-org'){
            $('#org-custom-range-modal').modal();
          }else if(root_id == 'search-news-tag'){
            $('#custom-range-modal').modal();
          }
        }else{
          // replace text in the button
          $btn.find('.text').html(txt);
          $input.val(val);
        }
      });

      $(document).on('click', '.btn-search', function(e){
        $('#search-submit-btn').click();
      });
    }
  }
  return {
    init: init
  };
})();

module.exports = TPBS_AdvSearch;

},{}],2:[function(require,module,exports){
/*global module:false */
"use strict";

var $ = window.$;

module.exports = (function(){
    var getWindowScrollTop = function(){
        return $(window).scrollTop();
    };
    var getWindowHeight = function(){
        return $(window).outerHeight();
    };
    var getDocumentHeight = function(){
        return $(document).outerHeight();
    };
    var getNavHeight = function(){
        return $('#header-nav').outerHeight();
    };
    var getTopNavHeight = function(){
        return $('#top-nav').outerHeight();
    };
    var getContentHeight = function(){
        return $('#content').outerHeight();
    };
    return {
        getWindowScrollTop: getWindowScrollTop,
        getWindowHeight: getWindowHeight,
        getDocumentHeight: getDocumentHeight,
        getNavHeight: getNavHeight,
        getTopNavHeight: getTopNavHeight,
        getContentHeight: getContentHeight
    };
})();

},{}],3:[function(require,module,exports){
/* global module:false */
"use strict";

var $ = window.$;
var common = require('./common');

var TPBS_footer = (function(){
    /**
     * Check scrollTop position and adjust back-to-top button position
     */
    var adjustBackToTopPosition = function(scrollTop, winHeight, docHeight, contentHeight, navHeight){
        var oriBackToTopPosition = navHeight + contentHeight;

        var $backToTopHolder = $('#back-to-top-holder');

        if(docHeight > winHeight){
            $backToTopHolder.addClass('fixed');
        }

        if(scrollTop > 0 && docHeight > winHeight && (scrollTop + winHeight < oriBackToTopPosition)){
            // show move to top button
            if(!$backToTopHolder.hasClass('move_up'))
                $backToTopHolder.addClass('move_up');
        }else if(scrollTop + winHeight > oriBackToTopPosition || scrollTop === 0){
            $backToTopHolder.removeClass('move_up');
        }
        if(scrollTop + winHeight > oriBackToTopPosition){
            $backToTopHolder.removeClass('fixed');
        }
    };

    /**
     * Scroll Event handler
     */
    var adjustBackToTopPositionHandler = function(){
        // get scroll top
        var scrollTop = common.getWindowScrollTop();
        // get window & document height
        var winHeight = common.getWindowHeight();
        var docHeight = common.getDocumentHeight();

        // check if we scroll down to see the back to top button original position
        var contentHeight = common.getContentHeight();

        var navHeight = common.getNavHeight();

        adjustBackToTopPosition(scrollTop, winHeight, docHeight, contentHeight, navHeight);
    };

    /**
     * Scroll to top
     */
    var scrollToTop = function(){
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 800, 'swing');
    };

    /**
     * Back to top btn click handler
     */
    var scrollToTopHandler = function(e){
        scrollToTop();
    }

    /**
     * Init Footer
     */
    var footerInit = function(){
        // handle move to top button position
        $(window).on('scroll', adjustBackToTopPositionHandler);
        adjustBackToTopPositionHandler();

        $(document).on('click', '#back-to-top-btn', scrollToTopHandler);
    };

    return {
        init: footerInit,
        adjustBackToTopPosition: adjustBackToTopPosition,
        scrollToTop: scrollToTop
    };
})();

module.exports = TPBS_footer;

},{"./common":2}],4:[function(require,module,exports){
/* global module:false */
"use strict";

var $ = window.$;
var common = require('./common');
// bootstrap
//require('../../bower_components/bootstrap-sass/assets/javascripts/bootstrap');

var TPBS_header = (function(){

    var _maxHeightNav = 500;
    var _currentScrollTop = 0;
    var _minDiff = 100;
    var _maxDirQueueLength = 10;
    var _dirQueue = [];


    /**
     * _maxHeightNav getter
     */
    var getNavMaxHeight = function(){
        return _maxHeightNav;
    };

    /**
     * _maxDirQueueLength getter
     */
    var getMaxDirQueueLength = function(){
        return _maxDirQueueLength;
    };

    /**
     * Adjust navbar max height when open main nav
     */
    var adjustNavBarMaxHeight = function(windowHeight, headerHeight){
        var maxHeightNav = getNavMaxHeight();
        var newMaxHeight = maxHeightNav;

        // check whether windowHeight < _maxHeightNav or not
        if(windowHeight <= maxHeightNav){
            // adjust max-height to new value
            newMaxHeight = windowHeight - headerHeight;
            $('#navbar').addClass('fixed');
        }else{
            $('#navbar').removeClass('fixed');
        }

        // set max height
        $('#navbar').css('max-height', newMaxHeight);
    };

    /**
     * Nav click Event handler
     */
    var adjustNavBarMaxHeightHandler = function(){
        if($(window).width() < 768){
            // get window height
            var wh = common.getWindowHeight();
            // get top nav height
            var th = common.getTopNavHeight();
            // adjust nav
            adjustNavBarMaxHeight(wh, th);
        }
    };

    /**
     * Adjust main-navbar max height when open main nav
     */
    var adjustMainNavBarMaxHeight = function(windowHeight, headerHeight){
        var diff = windowHeight - headerHeight;
        // set max height
        $('#main-navbar').css('max-height', diff);
    };

    /**
     * Main nav click Event handler
     */
    var adjustMainNavBarMaxHeightHandler = function(){
        if($(window).width() < 768){
            // get window height
            var wh = common.getWindowHeight();
            // get header height
            var hh = common.getNavHeight();
            // adjust main nav
            adjustMainNavBarMaxHeight(wh, hh);
        }
    };

    /**
     * _minDiff setter
     */
    var setMinDiff = function(minDiff){
        _minDiff = minDiff;
    };

    /**
     * _minDiff getter
     */
    var getMinDiff = function(){
        return _minDiff;
    };

    /**
     * _currentScrollTop setter
     */
    var setCurrentScrollTop = function(currentScrollTop){
        _currentScrollTop = currentScrollTop;
    };

    /**
     * _currentScrollTop getter
     */
    var getCurrentScrollTop = function(){
        return _currentScrollTop;
    };

    /**
     * Detect Scrolling direction
     */
    var detectScrollingDirection = function(newScrollTop, minDiff, currentScrollTop){
        var dir = 0;
        if(newScrollTop > currentScrollTop){
            // scroll down
            dir = 1;
        }else if(newScrollTop < currentScrollTop){
            dir = -1;
        }
        // check whether user scroll way back to the max top or not
        if(newScrollTop == 0){
            dir = -1; // show main nav
        }
        // check whether user scroll pass minimum height or not
        if(newScrollTop < minDiff){
            dir = -1; // show main nav
        }
        // update current scroll top
        setCurrentScrollTop(newScrollTop);

        return dir;
    }

    /**
     * _dirQueue setter
     */
    var setDirQueue = function(dirQueue){
        _dirQueue = dirQueue;
    }

    /**
     * _dirQueue getter
     */
    var getDirQueue = function(){
        return _dirQueue;
    }

    /**
     * Adjust Main nav position
     */
    var adjustMainNavPosition = function(dir, dirQueue){
        var move_dir = 0;

        // update queue
        // if queue if full, we remove the oldest queue
        if(dirQueue.length >= _maxDirQueueLength){
            dirQueue = _.drop(dirQueue);
        }
        // we a new dir to queue
        dirQueue.push(dir);

        if(dirQueue.length == _maxDirQueueLength){
            // iterate to see all of the queue is in the same direction
            var sumdir = _.reduce(dirQueue, function(sum, n){
                return sum + n;
            });
            // check if sum of current direction is equal to sum of move up/down direction
            if(sumdir == _maxDirQueueLength * -1){
                move_dir = -1;
            }else if(sumdir == _maxDirQueueLength){
                move_dir = 1;
            }
        }

        if(move_dir < 0){
            // scroll up, we show main nav
            $('#main-nav').removeClass('move_up');
            $('#header-nav').removeClass('hide-main-nav');
        }else if(move_dir > 0){
            // check if a user is open nav or not
            if(!$('#main-navbar').hasClass('in')){
                // scroll down, we hide main nav
                $('#main-nav').addClass('move_up');
                $('#header-nav').addClass('hide-main-nav');
            }
        }
        // otherwise, do nothing

        // update stored _dirQueue
        setDirQueue(dirQueue);
    }

    /**
     * Scrolling Event handler
     */
    var detectScrollingDirectionHandler = function(){
        // detect scrolling direction
        var newScrollTop = common.getWindowScrollTop();
        var currentScrollTop = getCurrentScrollTop();
        var minDiff = getMinDiff();
        var dir = detectScrollingDirection(newScrollTop, minDiff, currentScrollTop);
        var dirQueue = getDirQueue();
        adjustMainNavPosition(dir, dirQueue);
    };

    /**
     * Show search bar
     */
    var showSearchBar = function(){
        $('#open-search-btn').addClass('active');
        $('#search-bar-holder').addClass('active');
    };

    /**
     * Hide search bar
     */
    var hideSearchBar = function(){
        $('#open-search-btn').removeClass('active');
        $('#search-bar-holder').removeClass('active');
        clearSearchResult();
    };

    /**
     * Clear search input
     */
    var clearSearchResult = function(){
        $('#search-input').val('');
    };

    /**
     * Search button click handler
     */
    var showSearchBarHandler = function(e){
        showSearchBar();
    };
    var hideSearchBarHandler = function(e){
        hideSearchBar();
    };

    /**
     * Toggle other menu
     */
    var toggleOtherMenu = function(){
        if($('#other-btn').hasClass('active')){
            $('#other-btn').removeClass('active');
        }else{
            $('#other-btn').addClass('active');
        }
        if($('#other-menu-holder').hasClass('active')){
            $('#other-menu-holder').removeClass('active');
        }else{
            $('#other-menu-holder').addClass('active');
        }
        if($('#main-navbar').hasClass('show-other-menu')){
            $('#main-navbar').removeClass('show-other-menu');
        }else{
            $('#main-navbar').addClass('show-other-menu');
        }
    };

    /**
     * Other menu click handler
     */
    var toggleOtherMenuHandler = function(e){
        toggleOtherMenu();
    };

    /**
     * Init Header
     */
    var headerInit = function(){
        $(document)
            //.on('show.bs.collapse', '#navbar', adjustNavBarMaxHeightHandler)
            //.on('show.bs.collapse', '#main-navbar', adjustMainNavBarMaxHeightHandler)
            .on('click', '#open-search-btn', showSearchBarHandler) // show search bar
            .on('click', '#close-search-bar', hideSearchBarHandler) // hide search bar
            .on('click', '#other-btn', toggleOtherMenuHandler) // show/hide other menu
            .on('click', '.search-tablet-holder a', showSearchBarHandler) // show search bar for tablet

        //adjustMainNavBarMaxHeightHandler();

        setCurrentScrollTop(common.getWindowScrollTop());
        /*$(window)
            //.on('scroll', detectScrollingDirectionHandler)
            .on('resize', adjustNavBarMaxHeightHandler)
            .on('resize', adjustMainNavBarMaxHeightHandler);*/
    };

    return {
        init: headerInit,
        adjustNavBarMaxHeight: adjustNavBarMaxHeight,
        adjustMainNavBarMaxHeight: adjustMainNavBarMaxHeight,
        detectScrollingDirection: detectScrollingDirection,
        adjustMainNavPosition: adjustMainNavPosition,
        showSearchBar: showSearchBar,
        hideSearchBar: hideSearchBar,
        clearSearchResult: clearSearchResult,
        toggleOtherMenu: toggleOtherMenu,
        getMinDiff: getMinDiff,
        setMinDiff: setMinDiff,
        getCurrentScrollTop: getCurrentScrollTop,
        setCurrentScrollTop: setCurrentScrollTop,
        setDirQueue: setDirQueue,
        getDirQueue: getDirQueue,
        getNavMaxHeight: getNavMaxHeight,
        getMaxDirQueueLength: getMaxDirQueueLength
    };
})();

module.exports = TPBS_header;

},{"./common":2}],5:[function(require,module,exports){
/* global module:false */
"use strict";

var $ = window.$;

var TPBS_ticker = (function(){
  var rtime;
  var timeout = false;
  var delta = 200;

  var resizeTicker = function(){
      if (new Date() - rtime < delta) {
        setTimeout(resizeTicker, delta);
      } else {
        timeout = false;
        var w = $('#breaking-news-ticker > .container').width() 
          - $('#breaking-news-ticker .title').outerWidth()
          - $('#breaking-news-ticker .close-btn').outerWidth();
        $('#news-ticker').width(w);
        $('#news-ticker .marquee').width(w);
      }
  };

  var init = function(){
    // news ticker
    if($('#news-ticker').size() > 0){
        $('#news-ticker marquee').marquee('marquee');
        $('#content').addClass('show-ticker');
        // wait for init
        setTimeout(function(){
            $('#breaking-news-ticker').removeClass('hide');
            resizeTicker();
        }, 300);

        $(window).resize(function(){
            //resizeTicker();
            rtime = new Date();
            if (timeout === false) {
                timeout = true;
                setTimeout(resizeTicker, delta);
            }
        });
        $('#breaking-news-ticker .close-btn').on('click', function(){
            $('#breaking-news-ticker').fadeOut();
            $('#content').removeClass('show-ticker');
        });
    }
  }
  return {
    init: init
  };
})();

module.exports = TPBS_ticker;

},{}],6:[function(require,module,exports){
/*global TPBS:false */
'use strict';

window.TPBS = (function(){
    var TPBS_common = require('../components/common');
    var TPBS_header = require('../components/header');
    var TPBS_footer = require('../components/footer');
    var TPBS_AdvSearch = require('../components/adv-search');
    var TPBS_ticker = require('../components/ticker');

    /**
     * Main
     */
    var onReady = function(){

        TPBS_header.init();

        TPBS_footer.init();
        $('.whatsnews-block__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            //fade: true,
            //swipeToSlide: true,
            asNavFor: '.whatsnews-block__pagination'
        });
        $('.whatsnews-block__pagination').slick({
            slidesToShow: 10,
            slidesToScroll: 1,
            asNavFor: '.whatsnews-block__list',
            //dots: true,
            centerMode: false,
            focusOnSelect: true,
            inifinite: false,
            arrows: false,
        });

        $('.whatsnews-block__list').on('beforeChange', function(event,slick,slide,nextSlide) {
            $('.whatsnews-block__pagination').find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
        });

        TPBS_AdvSearch.init();

        TPBS_ticker.init();

    };

    /**
     * return public method
     */
    return {
        onReady: onReady,
        TPBS_common: TPBS_common,
        TPBS_header: TPBS_header,
        TPBS_footer: TPBS_footer,
        TPBS_AdvSearch: TPBS_AdvSearch
    };
})();

$(document).ready(TPBS.onReady);

// Enable Fastclick on touch devices
FastClick.attach(document.body);

},{"../components/adv-search":1,"../components/common":2,"../components/footer":3,"../components/header":4,"../components/ticker":5}]},{},[6])

